export const ConversionForm = {
  model: 'Conversion',
  format: [
    {
      widths: 'equal',
      fields: {
        from_unit: {
          type: 'dropdown search',
          url: '/main/unit-of-measures/',
          label: 'Select Default Unit of Measures',
          option_text_fields: ['plural_name'],
          title_fields: ['plural_name'],
          allow_add: true,
          description_fields: [],
          model: 'UnitOfMeasure',
          model_form: 'UnitOfMeasureForm',
        },
        to_unit: {
          type: 'dropdown search',
          url: '/main/unit-of-measures/',
          label: 'Select Default Unit of Measures',
          option_text_fields: ['plural_name'],
          title_fields: ['plural_name'],
          allow_add: true,
          description_fields: [],
          model: 'UnitOfMeasure',
          model_form: 'UnitOfMeasureForm',
        },
        multiplier: {
          type: 'number',
          min: '0',
          step: '0.000001',
        },
      },
    },
  ],
}
